import type { Components } from "react-markdown";
import LearningObjectiveCheckItem from "@/components/storyboard/text/LearningObjectiveCheckItem";
import LearningObjectiveCheckList from "@/components/storyboard/text/LearningObjectiveCheckList";

/**
 * react-markdown `ul` / `li` overrides for learning-objective checklists
 * (e.g. LEARNING_OBJECTIVE_ASSERTION markdown body).
 */
const learningObjectiveListComponents: Pick<Components, "ul" | "li"> = {
  ul: ({ children }) => (
    <LearningObjectiveCheckList>{children}</LearningObjectiveCheckList>
  ),
  li: ({ children }) => (
    <LearningObjectiveCheckItem>{children}</LearningObjectiveCheckItem>
  ),
};

export { learningObjectiveListComponents };
